import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function VideoSessionAccessContacts({ sessionDetails }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  const { organizationNumber, accountAccessNumber, appointmentNumber, sessionAccessCode } = sessionDetails;

  return (
    <div className={classes.accessContacts}>
      <div>
        <Typography variant="span" component="span">
          {`${t('you_can_also_call_in_to_your_video_session_at')}:`}
        </Typography>{' '}
        <Typography className={classes.guideLink} sx={{ fontWeight: 'bold' }} variant="span" component="span">
          {organizationNumber}
        </Typography>
      </div>
      <div>
        <Typography variant="span" component="span">
          {`${t('account_access_number')}:`}
        </Typography>{' '}
        <Typography sx={{ fontWeight: 'bold' }} variant="span" component="span">
          {accountAccessNumber}
        </Typography>
      </div>
      <div>
        <Typography variant="span" component="span">
          {`${t('appointment_number')}:`}
        </Typography>{' '}
        <Typography sx={{ fontWeight: 'bold' }} variant="span" component="span">
          {appointmentNumber}
        </Typography>
      </div>
      <div>
        <Typography variant="span" component="span">
          {`${t('session_access_code')}:`}
        </Typography>{' '}
        <Typography sx={{ fontWeight: 'bold' }} variant="span" component="span">
          {sessionAccessCode}
        </Typography>
      </div>
    </div>
  );
}

VideoSessionAccessContacts.propTypes = {
  sessionDetails: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default VideoSessionAccessContacts;
